import styled, { css } from 'styled-components';

export const AlertContainer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  width: 100%;
`;
export const AlertContent = styled.div<{
  paddingBottom: boolean;
}>`
  box-sizing: border-box;
  width: 100%;
  ${({ paddingBottom }) => css`
    padding-bottom: ${paddingBottom ? ' 8px' : '0px'};
  `}
`;
export const AlertTop = styled.div`
  align-items: center;
  border-radius: 15px 15px 0 0;
  display: flex;
  font-size: 1.5rem;
  font-weight: 400;
  justify-content: center;
  padding-top: 42px;
  text-align: center;
`;
export const AlertBottom = styled.div`
  align-items: center;
  border-radius: 0 0 15px 15px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: space-between;
  margin-top: 24px;
  padding: 0px 16px;
  width: 100%;
`;

export const AlertTitle = styled.div<{
  isMobile: boolean;
}>`
  ${({ isMobile }) => css`
    font-size: ${isMobile ? '18px' : '20px'};
    font-weight: 800;
    line-height: ${isMobile ? '23px' : '25px'};
    text-align: center;
    white-space: pre-line;
  `}
`;

export const AlertBody = styled.div<{
  isMobile: boolean;
}>`
  ${({ isMobile }) => css`
    font-size: ${isMobile ? '14px' : '16px'};
    font-weight: normal;
    line-height: ${isMobile ? '17.57px' : '20px'};
    margin-top: 16px;
    text-align: center;
    white-space: pre-line;
  `}
`;

export const AlertAction = styled.div<{
  isMobile: boolean;
}>`
  ${({ isMobile }) => css`
    align-items: center;
    box-sizing: border-box;
    display: flex;
    flex-direction: ${isMobile ? 'column-reverse' : 'row'};
    justify-content: center;
    margin-top: 32px;
    padding: 0px ${isMobile ? '20px' : '0px'};
    width: 100%;
  `}
`;

export const ButtonContainer = styled.div<{
  isMobile: boolean;
}>`
  flex: 1;
  width: 100%;
  ${({ isMobile }) => css`
    max-width: ${isMobile ? '100%' : '50%'};
    :not(:first-child) {
      margin-left: ${isMobile ? '0px' : '8px'};
    }
    :first-child:not(:only-child) {
      margin-right: ${isMobile ? '0px' : '8px'};
      margin-top: ${isMobile ? '16px' : '0px'};
    }
  `}
`;
